import React from 'react';
import { useWindowSize } from '@openedx/paragon';
import { useContextId } from '../../data/hooks';
import ProgressTabCertificateStatusSidePanelSlot from '../../plugin-slots/ProgressTabCertificateStatusSidePanelSlot';

import CourseCompletion from './course-completion/CourseCompletion';
import ProgressHeader from './ProgressHeader';

import ProgressTabCertificateStatusMainBodySlot from '../../plugin-slots/ProgressTabCertificateStatusMainBodySlot';
import ProgressTabCourseGradeSlot from '../../plugin-slots/ProgressTabCourseGradeSlot';
import ProgressTabGradeBreakdownSlot from '../../plugin-slots/ProgressTabGradeBreakdownSlot';
import ProgressTabRelatedLinksSlot from '../../plugin-slots/ProgressTabRelatedLinksSlot';
import CS136Grades from './markus-grades/CS136Grades';
import CS251Grades from './markus-grades/CS251Grades';
import { useModel } from '../../generic/model-store';

// Helper functions to determine course type
const isCS136 = (courseId) => courseId?.includes('CS136') && !courseId?.includes('CS136L');
const isCS251 = (courseId) => courseId?.includes('CS251');
const isUwCsCourse = (courseId) => isCS136(courseId) || isCS251(courseId);
const ProgressTab = () => {
  const courseId = useContextId();
  const { disableProgressGraph } = useModel('progress', courseId);
  // Fetch Markus data for UW CS courses
  const markusDataModel = useModel('markusData', courseId);
  const markusData = markusDataModel?.data;
  const hasMarkusData = isUwCsCourse(courseId) && markusData && Array.isArray(markusData);
  // UW Customization: Disable CourseGrade and GradeSummary components
  const disableCourseGrade = true;
  const disableGradeSummary = true;
  
  const windowWidth = useWindowSize().width;
  if (windowWidth === undefined) {
    // Bail because we don't want to load <CertificateStatus/> twice, emitting 'visited' events both times.
    // This is a hacky solution, since the user can resize the screen and still get two visited events.
    // But I'm leaving a larger refactor as an exercise to a future reader.
    return null;
  }

  return (
    <>
      <ProgressHeader />
      <div className="row w-100 m-0">
        {/* Main body */}
        <div className="col-12 col-md-8 p-0">
          <ProgressTabGradeBreakdownSlot />
          {/* UW CS Markus Grades Section */}
          {hasMarkusData && (
            <div className="markus-grades my-4 p-4 rounded raised-card">
              {isCS136(courseId) && <CS136Grades data={markusData} />}
              {isCS251(courseId) && <CS251Grades data={markusData} />}
            </div>
          )}
          
        </div>

        {/* Side panel */}
        <div className="col-12 col-md-4 p-0 px-md-4">
          <ProgressTabCertificateStatusSidePanelSlot />
          <ProgressTabRelatedLinksSlot />
        </div>
      </div>
    </>
  );
};

export default ProgressTab;
